/* import __COLOCATED_TEMPLATE__ from './attributes-table.hbs'; */
/**
Use `sq-card/attributes-table` to create a table of attributes in an `sq-card/attributes-list`.

| Description | Contextual Component |
| --- | --- |
| Header | [sq-card/attributes-table/header](./sq-card/attributes-table/header.html) |
| Header -> Header Cell | [sq-card/attributes-table/header-cell](./sq-card/attributes-table/header-cell.html) |
| Body | [sq-card/attributes-table/body](./sq-card/attributes-table/body.html) |
| Body -> Row | [sq-card/attributes-table/row](./sq-card/attributes-table/row.html) |
| Body -> Row -> Cell | [sq-card/attributes-table/cell](./sq-card/attributes-table/cell.html) |
*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'table',
  classNames: ['card__attributes-table']
});